module.exports = __webpack_public_path__ + "static/media/4.300bbc3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/cards/4.png
// module id = 258
// module chunks = 0